import React, { useState, useEffect, useRef } from "react";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import toast, { Toaster } from "react-hot-toast";
import { getWarehouseKeyValueList } from "../../../services/index";
import AddIcon from "@mui/icons-material/Add";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { getStockTransferDetails, getStockTransferList, logStockTransferHistory } from "../../../services/Inventory/OtherServices";
import Select from "react-select";
import { Dropdown, Table } from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";
import { useReactToPrint } from "react-to-print";
import { InsertDriveFile, LocalPrintshopOutlined } from "@mui/icons-material";
import ViewPdf from "../../Common/ViewPdf";
import { getFormattedNumber } from "../../utils/textUtils";

const StockTransferView = () => {
    const componentRef = useRef();
    let { id } = useParams();
    const navigate = useNavigate();
    const [filteredList, setFilteredList] = useState([]);
    const [list, setList] = useState([]);
    const [recordDetails, setRecordDetails] = useState([]);
    const [tabIndex, setTabIndex] = useState(0);
    const [wareOptions, setWareOptions] = useState(null);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(null);
    const [selectedWarehouse, setSelectedWarehouse] = useState({
        value: "",
        label: "Select Warehouse",
    });
    const [logData, setLogData] = useState({});
    const location = useLocation();
    const { state } = location;
    const warehouse = state && state.selectedWarehouse;
    let org = JSON.parse(localStorage.getItem("orgDetail"));



    useEffect(() => {
        if (id) {
            setTabIndex(0);
            getRecordDetails(id);
        }
    }, [id]);

    useEffect(() => {
        if (warehouse) {
            setSelectedWarehouse(warehouse);
        }
    }, [warehouse]);

    useEffect(() => {
        if (selectedWarehouse.value) {
            getList();
        }
    }, [selectedWarehouse.value])

    useEffect(() => {
        if (tabIndex === 1) {
            logHistory();
        }
    }, [tabIndex]);

    useEffect(() => {
        if (list && filteredList) {
            const result = list.filter((data) => {
                const stockTransferCode = data.stockTransferCode ? data.stockTransferCode.toLowerCase() : '';
                const createdAt = data.createdAt ? data.createdAt.toLowerCase() : '';

                return stockTransferCode.includes(search.toLowerCase()) || createdAt.includes(search.toLowerCase());
            });
            setFilteredList(result);
        }
    }, [search]);

    const logHistory = (id) => {
        if (id) {
            logStockTransferHistory(id).then((res) => {
                if (res.errorCode === 0) {
                    const d = res.responsePacket;
                    setLogData(d);
                } else {
                    toast(res.message);
                }
            });
        }
    }

    useEffect(() => {
        if (!wareOptions) {
            getWarehouseKeyValueList().then((res) => {
                if (res.errorCode === 0) {
                    let options = [];
                    res.responsePacket?.map((d) => {
                        options.push({
                            value: d.key,
                            label: d.value,
                        });
                    });
                    setWareOptions(options);
                } else {
                    toast(res.message);
                }
            });
        }
    }, []);

    const getList = () => {
        setLoading("list");
        let data = {
            page: 0,
            search: "",
            size: -1,
            uuid2: selectedWarehouse.value,
        };

        getStockTransferList(data)?.then((res) => {
            if (res.errorCode === 0) {
                let temp = res.responsePacket;
                setList(temp.data);
                if (temp?.data?.length > 0) {
                    const firstRecord = temp.data[0];
                    setTabIndex(0);
                    getRecordDetails(id ? id : firstRecord.uuid);
                }
                setFilteredList(temp.data);
                setLoading(null);
            } else {
                toast.error(res.message);
                setLoading(null);
            }
        });
    };

    const getRecordDetails = (uuid) => {
        getStockTransferDetails(uuid).then((res) => {
            if (res.errorCode === 0) {
                setRecordDetails(res.responsePacket);
            } else {
                toast.error(res.message);
            }
        });
    };

    const handleEdit = (uuid) => {
        navigate("/stockTransfer/" + uuid + "/edit");
    };

    const handleSelectWarehouse = (e) => {
        setSelectedWarehouse(e);
        getList(e.value);
        setSearch("");
    };
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const createEWayBill = (recordDetail) => {
        alert("This feature is not available right now")

    }

    return (
        <>
            <div className="list-column column d-print-none" style={{ width: "300px" }}>
                <div className="fill list-header topgrad d-print-none">
                    <div className="list-filter pt-3 d-flex align-items-center">
                        <div className="listFilterAndSearch">
                            <Link to="/stockTransfer/new" className="newListBtn">
                                <AddIcon />
                            </Link>
                            <div className="listFilter">
                                <Select value={selectedWarehouse} options={wareOptions} onChange={handleSelectWarehouse} />
                            </div>
                            <div className="input-group paginationSearchInput listSearch">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">
                                        <SearchRoundedIcon />
                                    </span>
                                </div>
                                <input autoComplete="off" className="form-control" type="text" placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="scroll-y fill body scrollbox list-body">
                    <div className="table-responsive overflow-initial">
                        {loading === "list" ? (
                            <div className="text-center my-2">Loading...</div>
                        ) : (
                            <table id="ember7912" className="table zi-table table-hover ember-view header-fixed">
                                <tbody>
                                    {filteredList &&
                                        (filteredList.length > 0 ? (
                                            filteredList.map((row, i) => (
                                                <tr
                                                    key={i}
                                                    onClick={() => {
                                                        setTabIndex(0);
                                                        getRecordDetails(row.uuid);
                                                    }}
                                                    className={`listTr ${id === row.stockTransferCode ? "activeRecord" : ""}`}
                                                >
                                                    <td>
                                                        <Link to={`/stockTransfer/${row.uuid}`} className={`${row.stockTransferCode === recordDetails.stockTransferCode ? "text-primary" : "text-grey"}`}>
                                                            <span className="titleTr">{row.stockTransferCode}</span>
                                                            <span className="d-flex justify-content-between">
                                                                <span>{row?.fromWarehouseTitle}</span>
                                                                <span>{row?.toWarehouseTitle}</span>
                                                            </span>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <div className="text-center my-2">No Records Found</div>
                                        ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>

            <div className="column content-column " style={{ left: "301px" }}>
                <div className="header no-border d-flex align-items-center p-4">
                    <h6 class="listTopHeading">
                        ( {recordDetails.stockTransferCode} )
                    </h6>
                    <a
                        className="over-flow header-title text-uppercase"
                        style={{ fontSize: "x-large" }}
                    >
                        &nbsp;
                    </a>
                    <div className="btn-toolbar d-flex justify-content-end align-items-center">
                        <Dropdown className="dropdownSection">
                            <Dropdown.Toggle>E-Way</Dropdown.Toggle>
                            <Dropdown.Menu>
                                <div
                                    className="dropdown-option"
                                    onClick={() => createEWayBill(recordDetails)}
                                >
                                    <AddIcon /> New Bill
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                        <div>
                            <button className="tooltip-container ember-view btn btn-primary print-btn" onClick={handlePrint}>
                                <LocalPrintshopOutlined />
                            </button>
                        </div>
                        <div className="btn-group mr-2 pr-0">
                            {recordDetails.stockTransferStatusEnum !== "Approved" && recordDetails.stockTransferStatusEnum !== "Cancelled" && <button
                                className="tooltip-container ember-view btn btn-primary print-btn m-0"
                                onClick={() =>
                                    handleEdit(
                                        recordDetails !== null ? recordDetails.uuid : null
                                    )
                                }
                            >
                                <EditIcon />
                            </button>}
                        </div>
                    </div>
                </div>
                <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)} className="upperTabs">
                    <TabList>
                        <Tab>Primary Details</Tab>
                        <Tab onClick={() => logHistory(recordDetails?.stockTransferCode)}>Log History</Tab>
                        <Tab>Batch Details</Tab>
                    </TabList>
                    <TabPanel>
                        {recordDetails && recordDetails.stockTransferItems && (
                            // <div  ref={componentRef} >
                            //     <br/>
                            //     <div className="stock-transfer-info d-flex">
                            //         <div className=" font-size-10 stock-transfer-from">Stock Transfer From: {recordDetails.fromWarehouseTitle}</div>
                            //         <div className="stock-transfer-to">Stock Transfer To: {recordDetails.toWarehouseTitle}</div>
                            //     </div>
                            //     <button className="tooltip-container ember-view btn btn-primary print-btn position-absolute" onClick={handlePrint} style={{ top: "10px", right: "0px" }}>
                            //         <LocalPrintshopOutlined />
                            //     </button>
                            //     <h3 className="font-size-16">ITEMS</h3>
                            //     <table className="customTable borderedTable">
                            //         <thead>
                            //             <tr>
                            //                 <td>S No.</td>
                            //                 <td>Item</td>
                            //                 <td>Transferred Pack Qty</td>
                            //                 <td>Transferred Loose Qty</td>
                            //             </tr>
                            //         </thead>
                            //         <tbody>
                            //             {recordDetails.stockTransferItems.map((item, i) => (
                            //                 <tr key={item.id || i}>
                            //                     <td>{i + 1}</td>
                            //                     <td>{item.itemTitle}</td>
                            //                     <td>{`${item.packStockQuantity} ${item.packStockUnitTitle}`}</td>
                            //                     <td>{`${item.openStockQuantity} ${item.openStockUnitTitle}`}</td>
                            //                 </tr>
                            //             ))}
                            //         </tbody>
                            //     </table>
                            // </div>

                            <ViewPdf
                                orderDetail={recordDetails}
                                itemList={recordDetails?.stockTransferItems}
                                address={recordDetails.address}
                                orgDetail={org}
                                // taxType={taxType}
                                from={recordDetails.fromWarehouseDetails}
                                to={recordDetails.toWarehouseDetails}
                                componentRef={componentRef}
                                pdfType={"stockTransfer"}
                                // keys={keys}
                                // values={values}
                                handlePrint={handlePrint}
                            // hsnKey={hsnKey}
                            // hsnVal1={hsnVal1}
                            // hsnVal2={hsnVal2}
                            />
                        )}
                    </TabPanel>
                    <TabPanel>
                        <div className="ember-view scroll-y noscroll-x fill body scrollbox py-3">
                            <table>
                                {logData.length === 0 ? (
                                    "No Changes Found"
                                ) : (
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Changes</th>
                                        </tr>
                                    </thead>
                                )}
                                {logData.length >= 1 && (
                                    <tbody>
                                        {logData?.map((history, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td className="mr-2" style={{ verticalAlign: "top", width: "100px" }}>
                                                        {history?.transactionDate?.substring(0, 10)}
                                                        <br />
                                                        Time:
                                                        {history?.transactionDate?.split("T")[1]?.substring(0, 5)}
                                                    </td>
                                                    <td>
                                                        <div dangerouslySetInnerHTML={{ __html: history?.message.replaceAll("\n", "<br />").replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;") }} />
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </TabPanel>
                    <TabPanel>
                    <div className="ember-view scroll-y noscroll-x fill body scrollbox py-3">
                        <table
                            style={{
                                width: '100%',
                                tableLayout: 'fixed',
                                clear: 'both',
                            }}
                            className='pcs-label'
                            id='itemTable'
                            cellSpacing={0}
                            cellPadding={0}
                            border='1px solid black'
                           ref={componentRef}
                        >
                            <thead>
                                <tr>
                                    <td style={{ width: '10%' }}>S.No.</td>
                                    <td style={{ width: '100%' }}>Item</td>
                                    <td style={{ width: '15%' }}>HSN/SAC</td>
                                    <td style={{ width: '10%' }}>Qty</td>
                                    <td style={{ width: '10%' }}>Rate</td>
                                </tr>

                            </thead>
                            <tbody >
                                {recordDetails?.stockTransferItems?.map((item, index) => {
                                    var quantity = item.openStockQuantity > 0 ? item.openStockQuantity : item.packStockQuantity
                                    var unit = item.openStockQuantity > 0 ? item.openStockUnitTitle : item.packStockUnitTitle

                                    return (
                                        <tr style={{marginLeft:"8px"}} key={index}>
                                            <td><div style={{width:"100%",marginLeft:"20px"}}>{index + 1}</div></td>
                                            <td>
                                                <span style={{borderBottom: "1px solid black" }}>{item.itemTitle}</span>
                                                <table style={{
                                                    width: '100%',
                                                    tableLayout: 'fixed',
                                                    clear: 'both',
                                                    marginTop:"10px"
                                                }}
                                                    className='pcs-label'
                                                    id='itemTable'
                                                    cellSpacing={0}
                                                    cellPadding={0}
                                                    border='1px solid black'>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "12%" }}>Batch No</th>
                                                            <th style={{ width: "12%" }}>Batch Qty</th>
                                                            <th style={{ width: "12%" }}>Mfg Date</th>
                                                            <th style={{ width: "12%" }}>Exp Date</th>
                                                            <th style={{ width: "12%" }}>Store</th>
                                                            <th style={{ width: "12%" }}>Rack</th>
                                                            <th style={{ width: "12%" }}>Cell</th>
                                                            <th style={{ width: "12%" }}>Pallete</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ fontWeight: "400" }}>
                                                        {(!item?.batchMultipleDetails||item?.batchMultipleDetails=="")?
                                                        <>
                                                        {item?.beanStockTransferBatchList && item?.beanStockTransferBatchList.map((e, index) => (
                                                            <tr key={index}>
                                                                <td>{e?.batchNumber}</td>
                                                                <td>{e?.batchQuantitySelected}</td>
                                                                <td>{e?.batchManufacturingDate}</td>
                                                                <td>{e?.batchExpiredDate}</td>
                                                                <td>{e?.storeTitle}</td>
                                                                <td>{e?.rackTitle}</td>
                                                                <td>{e?.cellTitle}</td>
                                                                <td>{e?.palletTitle}</td>
                                                            </tr>
                                                        ))}
                                                        </>
                                                        :<>
                                                        {item?.batchMultipleDetails && JSON.parse(item?.batchMultipleDetails).map((e, index) => (
                                                            <tr key={index}>
                                                                <td>{e?.batchNumber}</td>
                                                                <td>{e?.batchQuantitySelected}</td>
                                                                <td>{e?.batchManufacturingDate}</td>
                                                                <td>{e?.batchExpiredDate}</td>
                                                                <td>{e?.storeTitle}</td>
                                                                <td>{e?.rackTitle}</td>
                                                                <td>{e?.cellTitle}</td>
                                                                <td>{e?.palletTitle}</td>
                                                            </tr>
                                                        ))}
                                                        </>}
                                                       
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td>{item.hsnSac}</td>
                                            <td>
                                                {parseFloat(quantity)}&nbsp;
                                                {unit}
                                            </td>
                                            <td>{parseFloat(item.rate)}</td>

                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        </div>
                    </TabPanel>
                </Tabs>
            </div>
            <Toaster />
        </>
    );
};

export default StockTransferView;
